(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aov-cart-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.getElementById('aov-cart-analytics-config');
    if (!configElement || window.newbornkAovCartAnalytics) return;
    window.newbornkAovCartAnalytics = true;

    const config = JSON.parse(configElement.textContent);
    const openSelector = '.AOV-CartDrawer--open, #AOV-CDMinimal.AOV-CDMinimal--open';
    let root;
    let open = false;
    let generation = 0;
    let attempted = false;
    let controller;

    const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;

    async function track() {
      if (!open || attempted || !allowed()) return;
      attempted = true;
      const currentGeneration = generation;
      const request = new AbortController();
      controller = request;
      const timeout = setTimeout(() => request.abort(), 5000);

      try {
        const response = await fetch(config.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: request.signal,
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (!open || generation !== currentGeneration || !allowed()) return;
        if (!Array.isArray(cart.items) || !cart.items.length || !cart.currency) return;
        if (!Number.isFinite(cart.total_price) || cart.total_price < 0) return;
        if (cart.items.some(item => !item.product_id || !item.variant_id ||
          !Number.isInteger(item.quantity) || item.quantity <= 0 ||
          !Number.isFinite(item.final_line_price) || item.final_line_price < 0)) return;

        const items = cart.items.map(item => ({
          item_id: `shopify_UA_${item.product_id}_${item.variant_id}`,
          item_name: item.product_title,
          item_brand: item.vendor,
          item_variant: item.variant_title || '',
          price: item.final_line_price / item.quantity / 100,
          quantity: item.quantity,
        }));

        window.dataLayer = window.dataLayer || [];
        function send() { window.dataLayer.push(arguments); }
        send('event', 'view_cart', {
          send_to: 'G-6WKK4C3QWJ',
          currency: cart.currency,
          value: cart.total_price / 100,
          items,
          cart_source: 'aov_drawer',
        });
      } catch {
      } finally {
        clearTimeout(timeout);
      }
    }

    function sync() {
      const nextOpen = Boolean(root?.isConnected && root.querySelector(openSelector));
      if (nextOpen === open) return;
      open = nextOpen;
      generation += 1;
      attempted = false;
      controller?.abort();
      if (open) track();
    }

    const drawerObserver = new MutationObserver(sync);
    function connect() {
      if (root?.isConnected) return;
      drawerObserver.disconnect();
      root = document.getElementById('aov-cart-drawer');
      if (root) {
        drawerObserver.observe(root, {
          attributes: true, attributeFilter: ['class'], childList: true, subtree: true,
        });
      }
      sync();
    }

    new MutationObserver(connect).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visitorConsentCollected', () => {
      if (!allowed()) controller?.abort();
      else track();
    });
    connect();

    function loadPrivacy() {
      if (window.Shopify?.customerPrivacy) track();
      else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) track();
      });
    }
    loadPrivacy();
    window.addEventListener('load', loadPrivacy, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-selection-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.newbornkProductSelectionAnalytics) return;
    window.newbornkProductSelectionAnalytics = true;

    function trackSelection(event) {
      if (event.defaultPrevented) return;
      if (event.type === 'click' && event.button !== 0) return;
      if (event.type === 'auxclick' && event.button !== 1) return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;

      const target = event.target;
      if (!target?.closest) return;
      if (target.closest('button, [role="button"], input, select, textarea, .card__add-to-cart, [data-wlh-id], .wishlist-hero-custom-button')) return;
      const link = target.closest('a[data-nbk-selection]');
      if (!link || link.hasAttribute('download')) return;

      try {
        const payload = JSON.parse(link.getAttribute('data-nbk-selection'));
        if (!payload.item_list_id || !payload.item_list_name || payload.items?.length !== 1) return;
        if (!/^shopify_UA_\d+_\d+$/.test(payload.items[0].item_id)) return;
        window.dataLayer = window.dataLayer || [];
        function send() { window.dataLayer.push(arguments); }
        send('event', 'select_item', {
          send_to: 'G-6WKK4C3QWJ',
          item_list_id: payload.item_list_id,
          item_list_name: payload.item_list_name,
          items: payload.items,
        });
      } catch {
      }
    }

    document.addEventListener('click', trackSelection, true);
    document.addEventListener('auxclick', trackSelection, true);
    function loadPrivacy() {
      if (!window.Shopify?.customerPrivacy) {
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
      }
    }
    loadPrivacy();
    window.addEventListener('load', loadPrivacy, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
